<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">组别筛选</div>
			<el-form size="mini" :inline="true" @submit.native.prevent >
        <el-form-item style="min-width: 0px;">
        <el-button type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
        </el-form-item>
          <el-autocomplete
              class="inline-input"
              size="small"
              v-model="groupName"
              :fetch-suggestions="groupSelect"
              placeholder="请输入内容"
              @select="selected"
          ></el-autocomplete>

        <el-form-item style="min-width: 0px;padding-left: 20px">
          <el-button type="primary" icon="el-icon-search" @click="stuInport()">导入名单</el-button>
          <el-button v-show="groupInfo!=undefined" type="primary" icon="el-icon-search" @click="createPdf()">生成PDF</el-button>
          <el-button v-show="groupInfo!=undefined && groupInfo.status!=0" type="primary" icon="el-icon-search" @click="downloadPdf()">下载PDF</el-button>
        </el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<div class="c-title">学生评语列表</div>
			<el-table :data="stuList" size="mini">
        <el-table-column label="评语状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#99ffff" v-if="s.row.status==0" >初始</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#33ff66" v-if="s.row.status==1" >已填写</el-tag>
          </template>
        </el-table-column>
				<el-table-column label="姓名" prop="name"  width="80px"></el-table-column>
        <el-table-column label="学校" prop="school"  width="220px"></el-table-column>

        <el-table-column label="科目" prop="subject" width="200px"></el-table-column>
        <el-table-column label="评分" prop="rank" width="80px"></el-table-column>
				<el-table-column label="操作" width="240px">
        <template slot-scope="s">
          <el-button class="c-btn" type="primary" icon="el-icon-edit" @click="edit(s.row)">修改</el-button>
        </template>
				</el-table-column>
			</el-table>

		</div>

		<!-- 增改组件 -->
<!--		<add-or-update ref="add-or-update"></add-or-update>-->
<!--    <hour-or-update ref="hour-or-update"></hour-or-update>-->
    <addGroup ref="addGroup"></addGroup>
    <desStu ref="desStu"></desStu>
	</div>

</template>

<script>
  import addGroup from './des-create.vue';
  import desStu from './des-stu.vue';
	export default {
		components: {
      addGroup,desStu
		},
		data() {
			return {
        groupName:'',
        groupInfo:undefined,
        stuList:[],
			}
		},
		methods: {
			// 刷新
			f5: function(){
          this.stuList = [];
        let _this = this;
        this.sa.ajax('api/psdAdmin/des/getDesStudentList',
            {id:_this.groupInfo.id},
            function(res){
              this.stuList = res.data;
            }.bind(this));
			},
      // 添加
      add: function () {
        this.$refs['addGroup'].onOpen();
      },
      stuInport: function (){
        this.$refs['desStu'].onOpen(this.groupInfo.id);
      },
      groupSelect(queryString, cb){
			  let _this = this;
        this.sa.ajax('api/psdAdmin/des/getDesGroupList',
            {name:queryString},
            function(res){
              var data = [];
              res.data.forEach((item) => {
                data.push({id:item.id,name:item.name,value:item.name,school:item.school,subject:item.subject,status:item.status})
              })
              cb(data);
              console.log('组别列表',_this.groupList);
            }.bind(this));
      },
      createPdf(){
        this.sa.ajax('api/psdAdmin/des/createPdf',
            {id:this.groupInfo.id},
            function(res){
              console.log(res);
            }.bind(this));
      },
      downloadPdf(){
        // this.sa.ajax('api/psdAdmin/des/downloadPdf',
        //     {id:this.groupInfo.id},
        //     function(res){
        //       console.log(res);
        // }.bind(this));
        var url = "api/psdAdmin/des/downloadPdf?id="+this.groupInfo.id;
        window.location.href = url;
      },
      selected(item){
        this.groupInfo = item;
			  this.f5();
      },
      edit(data){
        var tab = {id: '110-'+data.id, name: '['+data.name+'] 评语', view: () => import('@/sa-view/des/des-info.vue'), params:{id:data.id,subject:this.groupInfo.subject}};
        this.sa_admin.showTab(tab);
      },
			// 修改
			update: function (data) {
				this.$refs['add-or-update'].open(data.id);
			},
      // 修改
      updateHour: function (data) {
        this.$refs['hour-or-update'].open(data.id);
      },
			// 删除
			del: function (data) {
				this.sa.confirm('是否删除，此操作不可撤销', function() {
					this.sa.ajax2('/goods/delete?id=' + data.id, function() {
						this.sa.arrayDelete(this.dataList, data);
						this.sa.ok('删除成功');
					}.bind(this))
				}.bind(this));
			},
		},
		created: function(){

		},
    filters: {

    }
	}
</script>
